declare namespace $ {

	type $mol_link__title_shm_showcase_1 = $mol_type_enforce<
		ReturnType< $shm_showcase['menu_title'] >
		,
		ReturnType< $mol_link['title'] >
	>
	type $mol_link__arg_shm_showcase_2 = $mol_type_enforce<
		({ 
			'component': any,
		}) 
		,
		ReturnType< $mol_link['arg'] >
	>
	type __shm_showcase_3 = $mol_type_enforce<
		Parameters< $shm_showcase['sort_by'] >[0]
		,
		Parameters< ReturnType< $shm_showcase['Menu'] >['sort_by'] >[0]
	>
	type __shm_showcase_4 = $mol_type_enforce<
		Parameters< $shm_showcase['sort_order'] >[0]
		,
		Parameters< ReturnType< $shm_showcase['Menu'] >['sort_order'] >[0]
	>
	type $mol_paragraph__title_shm_showcase_5 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_paragraph['title'] >
	>
	type $mol_list__rows_shm_showcase_6 = $mol_type_enforce<
		ReturnType< $shm_showcase['groups_visible'] >
		,
		ReturnType< $mol_list['rows'] >
	>
	type $mol_list__Empty_shm_showcase_7 = $mol_type_enforce<
		ReturnType< $shm_showcase['Empty'] >
		,
		ReturnType< $mol_list['Empty'] >
	>
	type $shm_showcase_table__entries_shm_showcase_8 = $mol_type_enforce<
		ReturnType< $shm_showcase['entries_ordered'] >
		,
		ReturnType< $shm_showcase_table['entries'] >
	>
	type $mol_page__title_shm_showcase_9 = $mol_type_enforce<
		string
		,
		ReturnType< $mol_page['title'] >
	>
	type $mol_page__body_shm_showcase_10 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $mol_page['body'] >
	>
	type $shm_list_page__title_shm_showcase_11 = $mol_type_enforce<
		ReturnType< $shm_showcase['menu_title'] >
		,
		ReturnType< $shm_list_page['title'] >
	>
	type $shm_list_page__head_content_shm_showcase_12 = $mol_type_enforce<
		readonly(any)[]
		,
		ReturnType< $shm_list_page['head_content'] >
	>
	type $shm_list_page__body_shm_showcase_13 = $mol_type_enforce<
		ReturnType< $shm_showcase['menu_body'] >
		,
		ReturnType< $shm_list_page['body'] >
	>
	type $shm_list_page__foot_shm_showcase_14 = $mol_type_enforce<
		ReturnType< $shm_showcase['menu_foot'] >
		,
		ReturnType< $shm_list_page['foot'] >
	>
	type $shm_list_page__filter_shm_showcase_15 = $mol_type_enforce<
		ReturnType< $shm_showcase['query'] >
		,
		ReturnType< $shm_list_page['filter'] >
	>
	type $shm_list_page__filter_hint_shm_showcase_16 = $mol_type_enforce<
		string
		,
		ReturnType< $shm_list_page['filter_hint'] >
	>
	type $shm_list_page__sort_options_shm_showcase_17 = $mol_type_enforce<
		({ 
			'title': string,
			'id': string,
		}) 
		,
		ReturnType< $shm_list_page['sort_options'] >
	>
	type $shm_showcase_group__title_shm_showcase_18 = $mol_type_enforce<
		ReturnType< $shm_showcase['group_title'] >
		,
		ReturnType< $shm_showcase_group['title'] >
	>
	type $shm_showcase_group__content_shm_showcase_19 = $mol_type_enforce<
		ReturnType< $shm_showcase['group_links'] >
		,
		ReturnType< $shm_showcase_group['content'] >
	>
	type $shm_showcase_component__entry_id_shm_showcase_20 = $mol_type_enforce<
		ReturnType< $shm_showcase['component_id'] >
		,
		ReturnType< $shm_showcase_component['entry_id'] >
	>
	type $shm_showcase_info__entry_id_shm_showcase_21 = $mol_type_enforce<
		ReturnType< $shm_showcase['component_id'] >
		,
		ReturnType< $shm_showcase_info['entry_id'] >
	>
	export class $shm_showcase extends $mol_book2_catalog {
		Theme( ): $mol_theme_auto
		Home( ): $mol_link
		query( next?: string ): string
		sort_by( next?: ReturnType< ReturnType< $shm_showcase['Menu'] >['sort_by'] > ): ReturnType< ReturnType< $shm_showcase['Menu'] >['sort_by'] >
		sort_order( next?: ReturnType< ReturnType< $shm_showcase['Menu'] >['sort_order'] > ): ReturnType< ReturnType< $shm_showcase['Menu'] >['sort_order'] >
		groups_visible( ): readonly($mol_view)[]
		Empty( ): $mol_paragraph
		Results( ): $mol_list
		group_title( id: any): string
		group_links( id: any): readonly($mol_view)[]
		component_id( id: any): string
		entries_ordered( ): readonly(any)[]
		Overview( ): $shm_showcase_table
		Welcome( ): $mol_page
		menu_title( ): string
		title( ): string
		param( ): string
		plugins( ): readonly(any)[]
		Menu( ): $shm_list_page
		menu_body( ): readonly(any)[]
		Group( id: any): $shm_showcase_group
		Spread( id: any): $shm_showcase_component
		Info( id: any): $shm_showcase_info
		Spread_default( ): ReturnType< $shm_showcase['Welcome'] >
	}
	
}

//# sourceMappingURL=showcase.view.tree.d.ts.map